import React from 'react';
import './App.css';

function App() {
  const searchQuery = window.location.search.substr(1);

  const arrSearchQuery = searchQuery.split('&');

  let checkoutClientKey = '';
  let apiKey = '';

  arrSearchQuery.forEach(query => {
    const arrQuery = query.split('=');

    if (arrQuery.length > 0) {
      if (arrQuery[0] === 'id') {
        checkoutClientKey = arrQuery[1];
      } else if (arrQuery[0] === 'key') {
        apiKey = atob(arrQuery[1] + '=');
      }
    }
  });

  if (checkoutClientKey !== '' && apiKey !== '') {
    const paymongo = new window.Paymongo(apiKey);

    paymongo.redirectToCheckout({
      checkoutClientKey: checkoutClientKey
    });
  }

  return (
    <div className="App">
      {checkoutClientKey && <span>Loading Shopify Data..</span>}
      {!checkoutClientKey && <span>Shopify data not found.</span>}
    </div>
  );
}

export default App;
